'use client'

import type { ComponentProps } from 'react'
import NextLink from 'next/link'

import { useLocale } from '~/hooks/use-locale.hook'
import { getLocalizedPath } from '~/i18n/routing'

type LocalizedLinkProps = ComponentProps<typeof NextLink>

const localizeHref = (
	href: LocalizedLinkProps['href'],
	locale: ReturnType<typeof useLocale>,
): LocalizedLinkProps['href'] => {
	if (typeof href === 'string') {
		return getLocalizedPath(href, locale)
	}

	if (href instanceof URL || href.protocol || href.host || !href.pathname) {
		return href
	}

	return {
		...href,
		pathname: getLocalizedPath(href.pathname, locale),
	}
}

export const LocalizedLink = ({ href, ...props }: LocalizedLinkProps) => {
	const locale = useLocale()

	return (
		<NextLink
			{...props}
			href={localizeHref(href, locale)}
		/>
	)
}
